import { useLocation, useHistory } from "react-router-dom"
import { allAlarmTypes } from "constants/statusBits"

export const toggleMapView = (urlSearch = "") => {
	const params = new URLSearchParams(urlSearch)
	const viewString = params.get("view")
	const viewList = viewString.split(",")
	let updatedViewList
	if (viewList.includes("map")) {
		updatedViewList = viewList.filter((viewItem) => viewItem !== "map")
	} else {
		updatedViewList = [...viewList, "map"]
	}
	params.set("view", updatedViewList.join(","))
	return `?${params.toString()}`
}

export const getMasterLocIds = (urlSearch = "") => {
	const params = new URLSearchParams(urlSearch)
	let locIds = params.get("locIds")
	if (!locIds) return []
	return locIds.split(",").map((loc) => loc.split(":")[0])
}

export const getNodeLocIdsByMasterLocId = (urlSearch = "") => {
	const params = new URLSearchParams(urlSearch)
	const activeIds = params.get("locIds")
	if (!activeIds) return {}
	const nLocIdsByMasterLocId = {}
	activeIds.split(",").forEach((ids) => {
		const [mLocId, nLocIds] = ids.split(":")
		if (!nLocIds) return null
		nLocIdsByMasterLocId[mLocId] = nLocIds
	})
	return nLocIdsByMasterLocId
}

export const clearNodeLocIds = (urlSearch = "") => {
	const params = new URLSearchParams(urlSearch)
	let locIds = params.get("locIds")
	if (!locIds) return urlSearch
	const mLocIds = locIds.split(",").map((ids) => {
		let [mLocId] = ids.split(":")
		return mLocId
	})
	params.set("locIds", mLocIds.join(","))
	return `?${params.toString()}`
}

const parseMask = (mask) => {
	const totalAlarmBits = allAlarmTypes.length
	const groupCount = Math.ceil(totalAlarmBits / 16)
	if (!mask) return new Array(groupCount).fill(0)
	const outMask = []
	for (let i = 0; i < groupCount; i++) {
		outMask.push(parseInt(mask.slice(i * 4, i * 4 + 4) || "0", 16))
	}
	return outMask
}

export const getMasks = (urlSearch = "") => {
	const params = new URLSearchParams(urlSearch)
	const filter = params.get("filter")
	return parseMask(filter)
}

export const updateMasks =
	(urlSearch = "") =>
	(eventCtrlKey, maskBit) => {
		const params = new URLSearchParams(urlSearch)
		const filter = params.get("filter")
		const newMasks = parseMask(filter)

		const totalAlarmBits = allAlarmTypes.length
		if (maskBit >= totalAlarmBits) return `?${params.toString()}`

		const group = Math.floor(maskBit / 16)
		const bit = 1 << maskBit % 16

		if (eventCtrlKey) {
			if ((newMasks[group] & bit) !== 0) {
				newMasks[group] &= ~bit
			} else {
				newMasks[group] |= bit
			}
		} else if ((newMasks[group] & bit) === 0 || (newMasks[group] & ~bit) !== 0) {
			newMasks[group] = bit
			for (let i = 0; i < newMasks.length; i++) {
				if (group !== i) {
					newMasks[i] = 0
				}
			}
		} else {
			newMasks[group] = 0
		}

		if (newMasks.reduce((prevValue, currValue) => prevValue && currValue === 0, true)) {
			params.delete("filter")
		} else {
			params.set(
				"filter",
				newMasks.reduce(
					(prevValue, currValue) => prevValue + currValue.toString(16).toUpperCase().padStart(4, "0"),
					"",
				),
			)
		}

		return `?${params.toString()}`
	}

export const useUrlParams = () => {
	const { search, pathname } = useLocation()
	const history = useHistory()

	const applyParamChange = (searchString) => {
		history.push({
			pathname,
			search: searchString,
		})
	}

	return {
		toggleMapView: () => applyParamChange(toggleMapView(search)),
		getMasterLocIds: () => getMasterLocIds(search),
		getNodeLocIdsByMasterLocId: () => getNodeLocIdsByMasterLocId(search),
		clearNodeLocIds: () => applyParamChange(clearNodeLocIds(search)),
		getMasks: () => getMasks(search),
		updateMasks: () => applyParamChange(updateMasks(search)),
	}
}
